"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function CompanyHistoryTimeline() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const timelineItems = [{
    id: 1,
    year: "1995",
    title: "Fundación de Kalisch Acero",
    description: "Iniciamos operaciones con la visión de transformar la industria del acero en la región."
  }, {
    id: 2,
    year: "2000",
    title: "Primera Gran Expansión",
    description: "Ampliamos nuestra capacidad logística y centros de distribución para cubrir nuevos territorios."
  }, {
    id: 3,
    year: "2005",
    title: "Mercados Internacionales",
    description: "Iniciamos la exportación de soluciones de acero, consolidando nuestra presencia global."
  }, {
    id: 4,
    year: "2010",
    title: "Iniciativa de Sostenibilidad",
    description: "Implementamos procesos de reciclaje y eficiencia energética líderes en la industria siderúrgica."
  }, {
    id: 5,
    year: "2015",
    title: "Adquisición Estratégica",
    description: "Fortalecimos nuestra cadena de valor mediante la integración de nuevas plantas de procesamiento."
  }, {
    id: 6,
    year: "2024",
    title: "Liderazgo en Innovación",
    description: "Alcanzamos hitos históricos en digitalización y soluciones de acero de alta resistencia."
  }];
  return <section data-section-id="258649" id="company-history-timeline" className="w-full bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {}
        <div ref={ref} className={`mb-16 text-center transition-all duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <span className="text-sm font-default font-semibold uppercase tracking-wider text-accent">
            Nuestra Trayectoria
          </span>
          <h2 className="mt-3 font-default text-3xl font-bold text-foreground md:text-5xl">Casi 47 Años Forjando el Futuro</h2>
          <p className="mt-4 text-lg text-muted-foreground font-default">
            Una historia de crecimiento, innovación y compromiso con la excelencia industrial.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="absolute left-1/2 top-0 h-full w-1 -translate-x-1/2 bg-border" />

          {}
          <div className="space-y-12">
            {timelineItems.map((item, index) => {
            const {
              ref: itemRef,
              isVisible: itemIsVisible
            } = useRevealOnScroll({
              threshold: 0.3
            });
            const isLeft = index % 2 === 0;
            return <div key={item.id} data-index={index} ref={itemRef} className={`relative transition-all duration-1000 ${itemIsVisible ? "opacity-100" : "opacity-0"}`}>
                  {}
                  <div className="absolute left-1/2 top-6 -translate-x-1/2">
                    <div className="flex h-16 w-16 items-center justify-center rounded-lg border-4 border-background bg-primary shadow-lg">
                      <span className="font-default font-bold text-primary-foreground text-sm">
                        {item.year}
                      </span>
                    </div>
                  </div>

                  {}
                  <div className={`flex ${isLeft ? "justify-start" : "justify-end"}`}>
                    <div className={`w-5/12 ${isLeft ? "text-right pr-8" : "text-left pl-8"}`}>
                      <div className={`rounded-lg border border-border bg-card p-6 shadow-md transition-all hover:shadow-xl hover:border-primary/30`}>
                        <h3 className="font-default font-bold text-foreground text-xl">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-sm text-muted-foreground font-default leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className="mt-16 text-center">
          <p className="mb-6 text-muted-foreground font-default">
            Sea parte de nuestra historia de éxito industrial
          </p>
          <Button variant="default" size="lg" className="font-default font-semibold bg-primary hover:bg-primary-600 text-primary-foreground rounded-md shadow-md transition-all">
            Conocer más sobre nosotros
          </Button>
        </div>
      </div>
    </section>;
}